import { updateProjectImg } from "../../../Features/projectImage";

import html2canvas from "html2canvas";

export const takeScreenshot = async (screenRef, dispatch) => {
  if (!screenRef) {
    return false;
  }
  try {
    const input = document.getElementById("firstMap");
    const dataURI = await html2canvas(input, { useCORS: true });
    dispatch(updateProjectImg({ ImageSrc: dataURI.toDataURL() }));
    return true;
  } catch (error) {
    return false; // Indicate failure
  }
};

export const handleNextClick = async ({
  roofInfo,
  screenRef,
  dispatch,
  setLoader,
  setEmptyValues,
  setShowMarker,
  navigate,
}) => {
  if (roofInfo.value.mapOption.mapTypeId === "girdView") {
    sessionStorage.setItem("projects", JSON.stringify(roofInfo));
    navigate("/analytics");
  } else {
    setShowMarker(false);
    setLoader(true);
    if (
      !roofInfo.value.siteName ||
      !roofInfo.value.siteAddress.value
    ) {
      setEmptyValues(true);
      setLoader(false);
      return false;
    } else {
      await takeScreenshot(screenRef, dispatch);
      sessionStorage.setItem("projects", JSON.stringify(roofInfo));
      navigate("/analytics");
    }
  }
};

export const backButton = ({ navigate }) => {
  const RemoveItem = [
    "projects",
    "cid",
    "customerName",
    "projectId",
    "lengthSides",
    "polygonCoordinates",
    "myData",
  ];
  RemoveItem.forEach((key) => {
    sessionStorage.removeItem(key);
  });
  navigate("/Dashboard");
  // window.location.pathname = "/Dashboard";
};
